import {useContext} from 'react';
import {Utils} from '../Utils';
import {AppContext} from '../App';
import './ThankPage.css';

export function ThankPage()
{
	const closure = useContext(AppContext);
	// const backBtnText = Utils.tr('BACK_BTN');
	const f1 =  Utils.tr('THANK_TITLE');
	const f2 =  Utils.tr('THANK_TEXT');
	const f3 =  Utils.tr('THANK_TEXT_2');
	const homeBtnText = Utils.tr('HOME_BACK_BTN');

	const onBackBtnClick = () =>
	{
		closure.dispatch({type: 'jump', page: 'home'});
	};

	return (
		<>
			<section className="box style-box">
		  		<div className="t-body">
		  			<h2 className="title is-2 has-text-centered">{f1}</h2>
		  			<p className="has-text-centered mb-5">
		  				<i className="fa fa-circle-check fa-6x has-text-primary"></i>
		  			</p>
		  			<h5 className="title is-5 has-text-centered">{f2}</h5>
		  			<p className="has-text-centered">{f3}</p>
				</div>
			</section>
			<div className="navigation">
				<div className="block has-text-centered">
					<button onClick={onBackBtnClick} className="button is-rounded is-warning is-light is-size-4 style-btn2">
						<i className="fa fa-home pr-2"></i>
						<span>{homeBtnText}</span>
					</button>
				</div>
			</div>
		</>
	);
}